import React from 'react';
import './App.css';
import ImageToPDF from './ImageToPDF';

function App() {
  return (
    <div className="App">
      <h1>Image to PDF Converter</h1>
      <ImageToPDF />
    </div>
  );
}

export default App;

